import { css, SimpleInterpolation } from "styled-components";
import { style } from "../style";

const defaultBorderRadius = style.vars.borderRadius.base;
const defaultBorderWith = style.vars.borderWidth.base;
const defaultBorderColor = style.colors.grey.dark;

export const focusOutline = ({
  top = style.vars.space["1"],
  right = style.vars.space["1"],
  bottom = style.vars.space["1"],
  left = style.vars.space["1"],
  borderRadius = defaultBorderRadius,
  borderWidth = defaultBorderWith,
  color = defaultBorderColor,
  margin = "0",
}: {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  borderRadius?: string;
  borderWidth?: string;
  color?: string;
  margin?: string;
} = {}): SimpleInterpolation => {
  return css`
    outline: none;
    position: relative;

    &:after {
      content: "";
      position: absolute;

      top: calc(-1 * ${top});
      right: calc(-1 * ${right});
      bottom: calc(-1 * ${bottom});
      left: calc(-1 * ${left});

      border-radius: ${borderRadius};
      border: ${borderWidth} dotted ${color};

      margin: ${margin};
    }
  `;
};

export const linkFocusOutline = ({
  borderRadius = defaultBorderRadius,
  borderWidth = defaultBorderWith,
  color = defaultBorderColor,
} = {}): SimpleInterpolation => {
  return css`
    &&:active,
    &&:focus {
      text-decoration: none;
      border-bottom-color: transparent;
      border-radius: ${borderRadius};
      outline: ${borderWidth} dotted ${color};
      margin: 0;
    }

    &&:hover {
      text-decoration: none;
      border-bottom-color: transparent;
    }
  `;
};
